import React, {
  FC,
  ReactChildren,
  useState
} from 'react';

import styled from '@emotion/styled';
import { variant, ThemeProps, LucidTheme } from '@lucid/theme';
import modalTheme from '@lucid/theme/src/theme/components/modal';
import ReactModal from 'react-modal';

import Icon from '../icon/icon';

export interface ModalProps extends ReactModal.Props {
  children: ReactChildren;
  theme: ThemeProps['theme'];
}

const StyledReactModal = styled(ReactModal)(
  variant({
    scale: 'modal',
    variants: {
      defaultVariant: {}
    }
  })
);

const Modal: FC<ModalProps> = (
  {
    children,
    isOpen,
    style,
    onRequestClose,
    ...rest
  }
) => {
  const [modalIsOpen, setModalIsOpen] = useState(isOpen || false);

  const handleOnClose = () => {
    if (onRequestClose) {
      onRequestClose;
    }
    setModalIsOpen(false);
  };

  return (
    <StyledReactModal
      {...rest}
      isOpen={modalIsOpen}
      onRequestClose={handleOnClose}
      style={modalTheme}
    >
      {children}
      <button
        css={(theme: LucidTheme) => ({
          background: 'transparent',
          border: 0,
          cursor: 'pointer',
          position: 'absolute',
          top: '-30px',
          right: '-30px',
          zIndex: theme.zIndices.z1100
        })}
        onClick={handleOnClose}
        onKeyPress={handleOnClose}
        tabIndex={0}
        type="button"
      >
        <Icon
          color="white"
          type="X"
        />
      </button>
    </StyledReactModal>
  );
};

export { Modal };
export default Modal;
